this.define=define;
